import cn from 'classnames';
import getAbbreviatedNum from '../utils/format';

interface PlanUsageProps {
  count: number;
  limit: number;
  message?: string;
  className?: string;
  children?: React.ReactNode;
}

export default function PlanUsage({ count, limit, message, className, children }: PlanUsageProps) {
  // excessive plan usage calculations
  const exceededDailyLimit = limit ? count > limit : 0;

  return (
    <div>
      <div className={cn('flex flex-col w-full justify-between', className)}>
        <div className="w-full mt-2 text-sm">{children}</div>
        <div className="text-4xl font-bold">
          <span style={{ color: exceededDailyLimit ? '#FFB21C' : 'white' }}>{count}</span>
          <span className={cn({ 'opacity-50': !exceededDailyLimit })}>
            <span className="px-1"> of </span>
            {limit ? getAbbreviatedNum(limit, true) : 'Unlimited'}
          </span>
        </div>
        {limit > 0 ? (
          <div className="relative h-1.5 w-full bg-blue-400 rounded-full mt-2">
            <div
              className={cn('absolute left-0 top-0 h-full rounded-full', {
                'bg-blue-100': !exceededDailyLimit,
              })}
              style={{
                width: `${Math.min(Math.round((count / limit) * 100), 100)}%`,
                background: exceededDailyLimit ? '#FFB21C' : '',
              }}
            />
          </div>
        ) : (
          <div className="w-full" />
        )}
      </div>
      <div className="mt-2 text-sm whitespace-nowrap">{message}&nbsp;</div>
    </div>
  );
}
